import $ from "jquery";

// Helper to convert base64url to Uint8Array
function base64urlToUint8Array(base64url) {
    // Replace base64url chars with base64 chars
    let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
    // Pad with '='
    while (base64.length % 4) base64 += '=';
    const str = atob(base64);
    const bytes = new Uint8Array(str.length);
    for (let i = 0; i < str.length; ++i) {
        bytes[i] = str.charCodeAt(i);
    }
    return bytes;
}

function getIdentityServerBasePath() {
    const path = window.location.pathname;
    const match = path.match(/^(.*?)(?:\/identityserver)?\/account\//i);
    if (match) {
        return match[1];
    }
    return '';
}

function showToast(message, type) {
    var toast = $("#toast");
    var toastMessage = $("#toastMessage");
    toastMessage.text(message);

    if (type === "success") {
        toast.removeClass("toast-error").addClass("toast-success");
    } else {
        toast.removeClass("toast-success").addClass("toast-error");
    }

    toast.addClass("show");

    setTimeout(function () {
        toast.removeClass("show");
    }, 5000);
}

export function initPasskeyRegister() {
    const registerBtn = document.getElementById('btn-register-passkey');
    const removeBtn = document.getElementById('btn-remove-passkey-verified');
    
    if (!registerBtn && !removeBtn) return;

    const basePath = getIdentityServerBasePath();

    if (registerBtn) {
        $('#btn-register-passkey').on('click', async function (e) {
            e.preventDefault();

            if (!window.PublicKeyCredential) {
                showToast('Passkey registration is not supported in this browser.', "failure");
                return;
            }

            try {
                // 1. Get registration options from server
                const res = await fetch(basePath + '/passkey/register/begin', {
                    headers: {
                        'Content-Type': 'application/json',
                        'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').value
                    },
                    method: 'POST'
                });
                if (!res.ok) throw new Error('Failed to get registration options');
                const options = await res.json();

                // 2. Convert all binary fields from base64url to Uint8Array
                options.challenge = base64urlToUint8Array(options.Challenge);

                // User handle
                let userHandleBytesAsString = atob(options.UserHandle);
                let userHandle = new Uint8Array(userHandleBytesAsString.length);
                for (let i = 0; i < userHandleBytesAsString.length; i++) {
                    userHandle[i] = userHandleBytesAsString.charCodeAt(i);
                }

                if (options.UserId) {
                    options.user = {};
                    options.user.id = userHandle;
                    options.user.displayName = options.UserId;
                    options.user.name = options.UserId;
                }
                if (options.ExcludedKeyIds) {
                    options.excludeCredentials = options.ExcludedKeyIds.map(cred => ({
                        ...cred,
                        id: base64urlToUint8Array(cred),
                        type: "public-key"
                    }));
                }
                options.pubKeyCredParams = [
                    { type: "public-key", alg: -8 },
                    { type: "public-key", alg: -259 },
                    { type: "public-key", alg: -39 },
                    { type: "public-key", alg: -36 },
                    { type: "public-key", alg: -258 },
                    { type: "public-key", alg: -38 },
                    { type: "public-key", alg: -35 },
                    { type: "public-key", alg: -7 },
                    { type: "public-key", alg: -257 },
                    { type: "public-key", alg: -37 },
                    { type: "public-key", alg: -7 },
                    { type: "public-key", alg: -65535 }
                ];

                if (options.RelyingPartyId) {
                    options.rp = {};
                    options.rp.id = options.RelyingPartyId;
                    options.rp.name = "YardiOne";
                }
                options.authenticatorSelection = {};
                options.authenticatorSelection.authenticatorAttachment = "cross-platform";
                options.authenticatorSelection.userVerification = "required";
                options.authenticatorSelection.requireResidentKey = true;

                // 3. Call WebAuthn API
                const cred = await navigator.credentials.create({ publicKey: options });

                // 4. Prepare data for server (convert ArrayBuffers to base64url)
                const attestation = {
                    id: cred.id,
                    rawId: btoa(String.fromCharCode.apply(null, new Uint8Array(cred.rawId))),
                    type: cred.type,
                    response: {
                        attestationObject: btoa(String.fromCharCode.apply(null, new Uint8Array(cred.response.attestationObject))),
                        clientDataJSON: btoa(String.fromCharCode.apply(null, new Uint8Array(cred.response.clientDataJSON)))
                    }
                };

                // 5. Send attestation to server
                const csrfToken = document.querySelector('input[name="__RequestVerificationToken"]')?.value;
                const headers = { 'Content-Type': 'application/json' };
                if (csrfToken) headers['RequestVerificationToken'] = csrfToken;

                const verifyRes = await fetch(basePath + '/passkey/register/complete', {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(attestation)
                });

                if (verifyRes.ok) {
                    showToast('Passkey registered successfully!', "success");
                    $("#btn-register-passkey").addClass("d-none");
                    $("#btn-remove-passkey").removeClass("d-none");
                } else {
                    const errorText = await verifyRes.text();
                    showToast(errorText || 'Registration failed.', "failure");
                }
            } catch (err) {
                showToast(err.message || 'Registration failed.', "failure");
            }
        });
    }

    if (removeBtn) {
        $('#btn-remove-passkey-verified').on('click', async function (e) {
            e.preventDefault();

            try {
                const res = await fetch(basePath + '/passkey/remove', {
                    headers: {
                        'Content-Type': 'application/json',
                        'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').value
                    },
                    method: 'POST'
                });
                if (!res.ok) throw new Error('Failed to remove passkey.');

                $("#btn-remove-passkey").addClass("d-none");
                $("#btn-register-passkey").removeClass("d-none");
                showToast('Passkey removed successfully.', "success");

            } catch (err) {
                showToast(err.message || 'Remove passkey failed.', "failure");
            }
        });
    }
}
